import { useLocation, useNavigate } from 'react-router-dom';
import ChannelsConfigurator from './accounts-channels-configurator.partial';
import Asaid from '../../components/layout/asaid.component';
import Header from '../../components/layout/header.component';
import Footer from '../../components/layout/footer.component';
import { AlertService } from '../../services/alert.service';
import { AccountsService } from '../../services/accounts.service';
import { useCallback, useEffect, useState } from 'react';

const ChannelsConfiguratorWrapper = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [channels, setChannels] = useState<any>([]);

  const getChannels = useCallback(async () => {
    if (!state?._id) return;
    try {
      const data = await AccountsService.getChannelsForAccount(state._id);
      setChannels(data);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  }, [state?._id]);

  useEffect(() => {
    if (state?._id) {
      getChannels();
    } else if (state && !state._id) {
      AlertService.toastError('No se encontró el ID de la cuenta');
      navigate('/accounts');
    } else if (!state) {
      AlertService.toastError('No se encontró información de la cuenta');
      navigate('/accounts');
    }
  }, [state, getChannels]);

  if (!state || !state._id) return null;

  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <Asaid />
      <div className="wrapper d-flex min-vh-100 flex-column flex-row-fluid" id="kt_wrapper">
        <Header />
        <div className="content fs-6  d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="post fs-6 d-flex flex-column-fluid mt-7" id="kt_post">
            <div className="container-xxl">
              <ChannelsConfigurator payload={channels} onSuccess={() => getChannels()} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ChannelsConfiguratorWrapper;
